/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorize-permission.vue?vue&type=template&id=fa601804&scoped=true&"
import script from "./authorize-permission.vue?vue&type=script&lang=js&"
export * from "./authorize-permission.vue?vue&type=script&lang=js&"
import style0 from "./authorize-permission.vue?vue&type=style&index=0&id=fa601804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa601804",
  null
  
)

export default component.exports